import "./App.css"
import "react-toastify/dist/ReactToastify.css"

import React, { Suspense, useEffect, useState } from "react"
import { Provider } from "react-redux"
import { BrowserRouter as Router, Route, Routes } from "react-router-dom"
import { ToastContainer } from "react-toastify"
import { TooltipProvider } from "react-tooltip"

import store from "./app/store"
import Layout from "./components/Layout"
import { isAuth } from "./helpers/auth"
import SessionContext from "./helpers/SessionContext"
import AdminRoute from "./routes/AdminRoute"
import PrivateRoute from "./routes/PrivateRoute"

// Lazy load components for better performance
const Landing = React.lazy(() => import("./screens/Landing"))
const Login = React.lazy(() => import("./screens/auth/Login"))
const Register = React.lazy(() => import("./screens/auth/Register"))
const ForgotPassword = React.lazy(() => import("./screens/auth/ForgotPassword"))
const ResetPassword = React.lazy(() => import("./screens/auth/ResetPassword"))
const Activate = React.lazy(() => import("./screens/auth/Activate"))
const Admin = React.lazy(() => import("./screens/auth/Admin"))
const Settings = React.lazy(() => import("./screens/auth/Settings"))
const ProjectsPage = React.lazy(() => import("./screens/ProjectsPage"))

// Loading component for Suspense fallback
const LoadingSpinner = () => (
  <div className="flex items-center justify-center min-h-screen">
    <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
  </div>
)

const App = () => {
  const [session, setSession] = useState(false)

  useEffect(() => {
    isAuth() ? setSession(true) : setSession(false)
  }, [session])

  return (
    <Provider store={store}>
      <SessionContext.Provider value={{ session, setSession }}>
        <TooltipProvider>
          <div
            className="App min-h-screen"
            style={
              isAuth()
                ? { backgroundColor: "white" }
                : { backgroundColor: "rgb(242, 245, 248)" }
            }
          >
            <Router>
              <Layout>
                <ToastContainer />
                <Suspense fallback={<LoadingSpinner />}>
                  <Routes>
                    <Route element={<Landing />} path="/" />
                    <Route element={<Login />} path="/login" />
                    {/* <Route element={<Register />} path="/register" /> */}
                    <Route
                      element={<ForgotPassword />}
                      path="/users/password/forgot"
                    />
                    <Route
                      element={<ResetPassword />}
                      path="/users/password/reset/:token"
                    />
                    <Route element={<Activate />} path="/users/activate/:token" />
                    <Route
                      element={
                        <AdminRoute>
                          <Admin />
                        </AdminRoute>
                      }
                      path="/admin/*"
                    />
                    <Route
                      element={
                        <PrivateRoute>
                          <Settings />
                        </PrivateRoute>
                      }
                      path="/settings/*"
                    />
                    <Route
                      element={
                        <PrivateRoute>
                          <ProjectsPage />
                        </PrivateRoute>
                      }
                      path="/projects"
                    />
                  </Routes>
                </Suspense>
              </Layout>
            </Router>
          </div>
        </TooltipProvider>
      </SessionContext.Provider>
    </Provider>
  )
}

export default App
